import { getCurrentTenant, type TenantId } from '@utils/tenant-utils'
import type { ForestOwnerProjectionModel } from '@/types/ForestOwners/ForestOwner'
import type { GetHistoricalEventsParams } from '@/types/ForestOwners/HistoricalEvents'
import type { GetSmsHistoryParams, SmsModel } from '@/types/ForestOwners/Sms'
import { apiGet, apiGetWithPagedResult, type PagedResult } from '../ApiClient'

export async function getForestOwnerHistoricalEvents(
  params: GetHistoricalEventsParams,
): Promise<PagedResult<ForestOwnerProjectionModel>> {
  const queryParams: Record<string, string> = {}
  if (params.dateFrom) {
    queryParams.dateFrom = params.dateFrom
  }
  if (params.dateTo) {
    queryParams.dateTo = params.dateTo
  }
  if (params.userId) {
    queryParams.userId = params.userId
  }
  if (params.userName) {
    queryParams.userName = params.userName
  }
  if (params.actions && params.actions.length > 0) {
    queryParams.actions = params.actions.join(',')
  }
  if (params.sort) {
    queryParams.sort = params.sort
  }

  const response = await apiGetWithPagedResult<ForestOwnerProjectionModel>(
    `/forestowners/${encodeURIComponent(params.forestOwnerId)}/historical-events`,
    {
      tenantId: params.tenantId,
      pageSize: params.pageSize,
      continuationToken: params.continuationToken,
    },
    {
      params: queryParams,
    },
  )
  return response
}
export async function getSmsHistory(params: GetSmsHistoryParams): Promise<PagedResult<SmsModel>> {
  const queryParams: Record<string, string> = {}
  if (params.dateFrom) {
    queryParams.dateFrom = params.dateFrom
  }
  if (params.dateTo) {
    queryParams.dateTo = params.dateTo
  }
  if (params.senderName) {
    queryParams.senderName = params.senderName
  }
  if (params.sort) {
    queryParams.sort = params.sort
  }

  const response = await apiGetWithPagedResult<SmsModel>(
    `/forestowners/${encodeURIComponent(params.forestOwnerId)}/sms`,
    {
      tenantId: params.tenantId,
      pageSize: params.pageSize,
      continuationToken: params.continuationToken,
    },
    {
      params: queryParams,
    },
  )
  return response
}

export async function getSmsSenders(forestOwnerId: string, tenantId?: TenantId): Promise<string[]> {
  const response = await apiGet<string[]>(
    `/forestowners/${encodeURIComponent(forestOwnerId)}/sms/senders`,
    {
      headers: {
        'x-tenant-id': tenantId ?? getCurrentTenant(),
      },
    },
  )

  return response
}
